import type { TileOf, TileStyle } from '@casa/model';
import type { IconDefinition } from '../../elements/icon.ts';
import { iconElement, type LayoutElement } from '../../elements/layout_elements.ts';

/**
 * The legacy `switch` tile (`SwitchTile.cs`, `SwitchTileView.xaml`): an icon for each state in a
 * colour for each, by default a toggle, yellow when on and grey when off; a tap switches it, as a
 * light. The state is not known before the first reading: then it shows as off, as the legacy
 * tile did.
 */

export type SwitchTile = TileOf<'switch'>;

export interface SwitchLook {
    icon: IconDefinition | undefined;
    color: string;
    /** The state's tile style (SW-1), over the tile's own. */
    style: TileStyle | undefined;
}

export function switchTileLook(tile: SwitchTile, on: boolean | null, icons: { on: IconDefinition | undefined; off: IconDefinition | undefined }) : SwitchLook {
    const { options } = tile;

    return on === true ? { icon: icons.on, color: options.onColor, style: options.onStyle } : { icon: icons.off, color: options.offColor, style: options.offStyle };
}

export function switchTileElements(look: SwitchLook) : LayoutElement[] {
    return [iconElement({ center: 'parent.center', w: 'parent.width*0.8', h: 'parent.height*0.8' }, look.icon, look.color, { fill: true })];
}
